export default (api) => ({
  getFilteredMerchants: (body, params) => api.post('/merchants/filter', body, { params }),
  getMerchantInfo: (id) => api.get(`/merchants/${id}`),
  createMerchant: (data) => api.post('/merchants', data),
  getIndustries: () => api.get('/merchants/industries'),
  getPartners: () => api.get('/merchants/partners'),
  getMerchantEmployees: (id, params) => api.get(`/merchants/${id}/employees`, { params }),
  getMerchantEmployeeInfo: (id) => api.get(`/merchants/employees/${id}`),
  createMerchantEmployee: (id, data) => api.post(`/merchants/${id}/employees`, data),
  updateMerchantEmployee: (id, data) => api.put(`/merchants/employees/${id}`, data),
  getBanks: () => api.get('/merchants/banks'),
  getAccounts: (params) => api.get('/merchants/merchants-accounts', { params }),
  updateMerchantConfigs: (id, data) => api.patch(`/merchants/${id}/config`, data),
  updateMerchantRates: (id, data) => api.patch(`/merchants/${id}/rate`, data),
  updateMerchantAccount: (id, data) => api.patch(`/merchants/${id}/account`, data),
  updateMerchantStatus: (id, active) => api.patch(`/merchants/${id}/status`, { active }),
  sendOnboardingEmail: (id, emails) => api.post(`/merchants/${id}/send-onboarding`, {
    emails
  }),
  getOnboardingMessage: (id) => api.get(`/merchants/${id}/onboarding-message`)
})
